import { render, staticRenderFns } from "./BaseAlertBox.vue?vue&type=template&id=0d7fb4c0&scoped=true"
import script from "./BaseAlertBox.vue?vue&type=script&lang=js"
export * from "./BaseAlertBox.vue?vue&type=script&lang=js"
import style0 from "./BaseAlertBox.vue?vue&type=style&index=0&id=0d7fb4c0&prod&scoped=true&lang=css"
import style1 from "./BaseAlertBox.vue?vue&type=style&index=1&id=0d7fb4c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7fb4c0",
  null
  
)

export default component.exports